import {
  Box,
  CircularProgress,
  List,
  Skeleton,
  Typography,
} from "@mui/material";
import { ConversationDto } from "libs/cellera-sdk";

import { useCelleraTheme } from "../../theme/useCelleraTheme";
import ConversationItem from "./ConversationItem";

type ConversationListProps = {
  isLoading?: boolean;
  selectedConversationId?: string;
  conversations: ConversationDto[];
  onSelect: (conversation: ConversationDto) => void;
  isLoadingMore?: boolean;
};

const ConversationList: React.FC<ConversationListProps> = ({
  selectedConversationId,
  conversations,
  isLoading,
  onSelect,
  isLoadingMore,
}: ConversationListProps) => {
  const { colors } = useCelleraTheme();

  if ((!conversations || !conversations?.length) && !isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "200px",
          padding: 2,
        }}
      >
        <Typography variant="body2" sx={{ color: colors.text.secondary }}>
          No conversations found.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        paddingRight: "8px",
        backgroundColor: colors.background.paper,
      }}
    >
      {/* Conversation List */}
      <List sx={{ padding: 0 }}>
        {conversations?.map((conversation) => {
          const isSelected = selectedConversationId === conversation.id;
          return (
            <ConversationItem
              key={conversation.id}
              isSelected={isSelected}
              onSelect={onSelect}
              {...conversation}
            />
          );
        })}

        {isLoading &&
          Array.from({ length: 5 }).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              width="100%"
              height={72}
              sx={{ marginBottom: 0.5 }}
              animation="wave"
            />
          ))}
      </List>
      {isLoadingMore && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: 2,
          }}
        >
          <CircularProgress size={16} />
        </Box>
      )}
    </Box>
  );
};

export default ConversationList;
